export default __webpack_public_path__ + "static/media/meals_card_2@2x.0c4f9722.png";